import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root',
})
export class SearchStringService {
    searchControl = new FormControl('');

    clearSearchString() {
        this.searchControl.setValue('');
    }

    get value() {
        return this.searchControl.value;
    }

    signalSearchControl = toSignal(this.searchControl.valueChanges);
}
